import { render, staticRenderFns } from "./RemovedItem.vue?vue&type=template&id=6f3a8b17&scoped=true&"
import script from "./RemovedItem.vue?vue&type=script&lang=ts&"
export * from "./RemovedItem.vue?vue&type=script&lang=ts&"
import style0 from "./RemovedItem.vue?vue&type=style&index=0&id=6f3a8b17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a8b17",
  null
  
)

export default component.exports